// public/js/modules/logger.js



const LOGGING_ENABLED = true;


function writeLog(level, message, ...args) {
    if (!LOGGING_ENABLED && level === 'INFO') {
        return; 
    }

    const prefixMap = {
        INFO: '[INFO]',
        WARN: '[WARN]',
        ERROR: '[ERROR]',
    };

    const logFunction = console[level.toLowerCase()] || console.log;

    logFunction(`${prefixMap[level]} ${message}`, ...args);
}


export const log = {
    info: (message, ...args) => writeLog('INFO', message, ...args),
    warn: (message, ...args) => writeLog('WARN', message, ...args),
    error: (message, ...args) => writeLog('ERROR', message, ...args),
};